/**
 * product-add-ons.js
 * Manages the accessories upsell widget on the product page.
 *
 * - Widget renders ABOVE the original ATC button
 * - Original ATC button stays visible and is used as-is
 * - On ATC submit, any checked accessories are bundled into the same cart add
 * - Strips the main product's model prefix from accessory names in the display
 * - Updates live price total as checkboxes change
 */

(function () {
  'use strict';

  var widget = document.getElementById('product-add-ons');
  if (!widget) return;

  var checkboxes  = widget.querySelectorAll('.product-add-ons__checkbox');
  var countEl     = widget.querySelector('.product-add-ons__count');
  var totalEl     = widget.querySelector('.product-add-ons__total');
  var productTitle = widget.dataset.productTitle || '';

  // ── Find ATC form ─────────────────────────────────────────────────────────
  var atcForm = document.querySelector('form[action="/cart/add"]');
  if (!atcForm) return;

  // ── Strip common model prefix from accessory names ────────────────────────
  // e.g. "Cummins Onan P11000iTF Natural Gas Hose Kit" → "Natural Gas Hose Kit"
  // Builds a prefix from the product title words, tries progressively shorter
  // prefixes until one matches. Falls back to full title if nothing matches.
  function shortenName(fullTitle) {
    if (!productTitle) return fullTitle;
    // Try removing the product title prefix (exact match first)
    if (fullTitle.indexOf(productTitle) === 0) {
      return fullTitle.slice(productTitle.length).replace(/^[\s|–\-]+/, '').trim();
    }
    // Try word-by-word prefix matching (handles truncated product titles)
    var words = productTitle.split(' ');
    for (var i = words.length; i >= 2; i--) {
      var prefix = words.slice(0, i).join(' ');
      if (fullTitle.indexOf(prefix) === 0) {
        return fullTitle.slice(prefix.length).replace(/^[\s|–\-]+/, '').trim();
      }
    }
    return fullTitle;
  }

  // Apply shortened names to the DOM
  checkboxes.forEach(function (cb) {
    var nameEl = cb.closest('.product-add-ons__item')
                   && cb.closest('.product-add-ons__item').querySelector('.product-add-ons__name');
    if (nameEl) {
      var short = shortenName(nameEl.textContent.trim());
      // Also strip trailing " | SKU" part
      short = short.replace(/\s*\|\s*[A-Z0-9]+$/, '').trim();
      if (short) nameEl.textContent = short;
    }
  });

  // ── Utility: get current variant ID ───────────────────────────────────────
  function getVariantId() {
    var idInput = atcForm.querySelector('input[name="id"]')
      || atcForm.querySelector('select[name="id"]');
    return idInput ? parseInt(idInput.value, 10) : null;
  }

  // ── Update summary line ───────────────────────────────────────────────────
  function updateSummary() {
    var count = 0;
    var totalCents = 0;
    checkboxes.forEach(function (cb) {
      var row = cb.closest('.product-add-ons__item');
      if (cb.checked) {
        count++;
        totalCents += parseInt(cb.dataset.price, 10) || 0;
        if (row) row.classList.add('is-checked');
      } else {
        if (row) row.classList.remove('is-checked');
      }
    });

    countEl.textContent = count;

    if (count > 0) {
      var dollars = (totalCents / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      totalEl.textContent = '+' + dollars;
    } else {
      totalEl.textContent = '$0.00';
    }
  }

  checkboxes.forEach(function (cb) {
    cb.addEventListener('change', updateSummary);
  });
  updateSummary();

  // Re-sync when variant selection changes
  atcForm.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (el) {
    el.addEventListener('change', updateSummary);
  });

  // ── Cart open helpers ──────────────────────────────────────────────────────
  function tryOpenCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    var cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble) { cartIconBubble.click(); return true; }
    var drawerTrigger = document.querySelector('[data-cart-toggle], [data-cart-open], .js-cart-open');
    if (drawerTrigger) { drawerTrigger.click(); return true; }
    return false;
  }

  // ── Intercept the original ATC form submit ────────────────────────────────
  // If accessories are checked, prevent default and bundle everything together.
  // If none checked, let the form submit normally — zero disruption.
  atcForm.addEventListener('submit', function (e) {
    var checked = [];
    checkboxes.forEach(function (cb) {
      if (cb.checked) checked.push({ id: parseInt(cb.value, 10), quantity: 1 });
    });
    if (checked.length === 0) return; // no accessories — normal ATC submit

    e.preventDefault();
    e.stopImmediatePropagation();

    var variantId = getVariantId();
    if (!variantId) {
      alert('Please select product options before adding to cart.');
      return;
    }

    var originalBtn = atcForm.querySelector('[type="submit"]');
    var originalText = originalBtn ? originalBtn.textContent : '';
    if (originalBtn) {
      originalBtn.disabled = true;
      originalBtn.textContent = 'Adding\u2026';
    }

    var items = [{ id: variantId, quantity: 1 }].concat(checked);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Cart add failed'); });
        return r.json();
      })
      .then(function () {
        if (originalBtn) {
          originalBtn.disabled = false;
          originalBtn.textContent = originalText;
        }
        var opened = tryOpenCartDrawer();
        if (!opened) {
          setTimeout(function () {
            var drawer = document.querySelector('cart-drawer, #CartDrawer, #cart-drawer, [id*="cart-drawer"]');
            if (!drawer) window.location.href = '/cart';
          }, 400);
        }
      })
      .catch(function (err) {
        if (originalBtn) {
          originalBtn.disabled = false;
          originalBtn.textContent = originalText;
        }
        console.error('[product-add-ons] cart error:', err);
        alert('Something went wrong adding to cart. Please try again.');
      });
  });
})();
